import * as React from 'react';
import PageBase from '../../components/layout/PageBase';

const styles = {
  headerText: {
    color: 'black',
    textDecoration: 'underline',
  },
};

const PrivacyComponent = () => (
  <PageBase title="Torii - Privacy Policy">
    <div
      className="page-container legal-container"
      style={{
        width: '90%',
        maxWidth: 800,
        margin: '0 auto',
      }}
    >
      <h4 style={{ textAlign: 'center' }}>
        TORII, INC.
        <br />
        PRIVACY POLICY
        <br />
        Last Updated: November 8, 2021
      </h4>
      <p>
        This privacy policy (“Policy”) describes how Torii, Inc. and its related
        companies (“Company”) collect, use and share personal information of
        consumer users of this website, www.toriihomes.com (the “Site”) and the
        Torii mobile application (“App”) to search for homes, tour homes, make
        offers on homes, compare home prices or otherwise evaluate and inform
        their home buying decisions (“Services”). This Policy also applies to
        any of our other websites that link to this Policy.
      </p>
      <br />
      <p>
        Click on the links below to go to a specific section of this Policy.
      </p>
      <div>
        <ol style={{ listStyleType: 'decimal' }}>
          <li>
            <a href="#whatWeCollect">What We Collect</a>
          </li>
          <li>
            <a href="#useOfPersonalInfo">Use of Personal Information</a>
          </li>
          <li>
            <a href="#sharingPersonalInfo">Sharing of Personal Information</a>
          </li>
          <li>
            <a href="#protectPersonalInfo">
              How We Protect Your Personal Information
            </a>
          </li>
          <li>
            <a href="#infoChoices">Your Information Choices</a>
          </li>
          <li>
            <a href="#contactTorii">Contacting Torii</a>
          </li>
          <li>
            <a href="#changes">Changes to this Policy</a>
          </li>
        </ol>
      </div>
      <br />
      <ol style={{ listStyleType: 'decimal' }}>
        <li>
          <h4>
            <a id="whatWeCollect" style={styles.headerText}>
              WHAT WE COLLECT
            </a>
          </h4>
          <p>
            We collect personal information when you use our Services. In this
            section we will explain the types and sources of information we
            collect from you.
          </p>
          <ul>
            <li>
              <p>
                <strong>Information You Provide to Us.</strong> We collect
                certain types of information from you directly. We collect this
                information when you register for an account or use our Services
                through the Site or App.
              </p>

              <ul style={{ listStyleType: 'circle' }}>
                <li>
                  Account Registration Information. We will collect certain
                  contact information to allow you to register an account with
                  us and to communicate with you. We will collect information
                  such as your first and last name, your e-mail address, and
                  your phone number. We collect this information in order to
                  register your account and communicate with you about your
                  account or your use of our Services.
                </li>
                <li>
                  Home Search Preferences. We may collect information from you
                  about your home buying preferences. If you are using our
                  Services to search for a home to buy we will collect
                  information such as your preferred location, your preferred
                  home size, the number of bedrooms and bathrooms you would like
                  your home to have. We collect this information from you to
                  show you the types of homes that you would be most interested
                  in purchasing.
                </li>
                <li>
                  Real Estate Transaction Information. We may collect
                  information from you regarding your real estate purchase or
                  selling status. If you are buying a home, we may collect
                  information about your identity such as your legal name as it
                  appears on your driver’s license and information about your
                  mortgage including your lending institution and the amount of
                  your mortgage. We collect this information pursuant to your
                  decision to make an offer using our Services.
                </li>
                <li>
                  Communications Information. We may collect information about
                  you when you speak with one of our professionals by phone or
                  through our chat services. Information we may collect through
                  these communications is used to improve your experience on our
                  Site or App and provide you with assistance or information
                  related to your use of our Services.
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Information We Get From Others.</strong> We may get
                information about you from other sources. We may add this to
                information we get from the Site or App.
              </p>
              <ul style={{ listStyleType: 'circle' }}>
                <li>
                  Account Authentication Information. When you provide us with
                  permission to use biometric information to authenticate your
                  account, we may collect certain mathematical information about
                  your face that is stored on your device. You may opt out of
                  sharing this information at any time by turning it off in your
                  account on the App.
                </li>
                <li>
                  Consumer Reporting Information. We may receive certain
                  nonpublic personal information from consumer reporting
                  agencies about you in order to provide you with our Services.
                </li>
                <li>
                  Information from our Service Providers, Partners and
                  Affiliates. We may collect information about you from our
                  Partners and Affiliates such as lenders and real estate
                  brokers who we partner with to provide you with Services.
                </li>
                <li>
                  Publicly Available Information. We sometimes collect
                  information from public government sources in order to help
                  you purchase or sell a home. We may collect information about
                  your deed, sales information about homes similar to yours as
                  well as permits, liens, or tax assessments on your home.
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Information Automatically Collected.</strong> We
                automatically log information about you and your computer or
                device. For example, when visiting our Site or App, we log your
                computer or device operating system type, browser type, browser
                language, [IP address], the website you visited before browsing
                to our Site, pages you viewed, how long you spent on a page,
                access times and information about your use of and actions on
                our Site or App.
              </p>
            </li>
            <li>
              <p>
                <strong>Cookies.</strong> We may log information using
                &quot;cookies&quot;. Cookies are small data files stored on your
                hard drive by a website. We may use both session Cookies (which
                expire once you close your web browser) and persistent Cookies
                (which stay on your computer until you delete them) to provide
                you with a more personal and interactive experience on our Site.
                This type of information is collected to make the Site more
                useful to you and to tailor the experience with us to meet your
                special interests and needs.
              </p>
            </li>
          </ul>
        </li>
        <br />
        <li>
          <h4>
            <a id="useOfPersonalInfo" style={styles.headerText}>
              USE OF PERSONAL INFORMATION
            </a>
          </h4>
          <p>We use your personal information as follows:</p>
          <ul>
            <li>
              <strong>Provide Our Services.</strong> We use information we
              collect to provide our services and improve your experience on our
              Site and App. This information helps us show you homes that may
              interest you and deliver personalized content that may help you
              use our Services.
            </li>
            <li>
              <strong>To Communicate With You.</strong> We use your personal
              information to send you information including confirmations,
              invoices, technical notices, updates, security alerts, and support
              and administrative messages. We also use personal information to
              communicate with you about your use of our Services related to
              your interests in purchasing a home.
            </li>
            <li>
              <strong>Marketing and Promotions.</strong> We use your personal
              information to communicate about promotions, upcoming events, and
              other news about products and services offered by us and our
              selected partners.
            </li>
            <li>
              <strong>Market Research.</strong> We use your personal information
              to aggregate it with other Users and conduct market research on
              home searching and purchasing activity in markets where we provide
              our Services
            </li>
            <li>
              <strong>Fraud Detection and Prevention.</strong> We use your
              personal information to protect, investigate, and deter against
              fraudulent, unauthorized, or illegal activity.
            </li>
            <li>
              <strong>Information Security.</strong> We use your personal
              information to ensure the security of our Site and App and to
              investigate any unauthorized attempts to access personal
              information
            </li>
            <li>
              <strong>Dispute Resolution.</strong> We may use your personal
              information to defend our legal rights against claims brought in
              court or other dispute resolution forums.
            </li>
          </ul>
        </li>
        <br />
        <li>
          <h4>
            <a id="sharingPersonalInfo" style={styles.headerText}>
              SHARING OF PERSONAL INFORMATION
            </a>
          </h4>
          <p>We may share personal information as follows:</p>
          <ul>
            <li>
              <strong>When You Request.</strong> At your request, we will share
              personal information to provide Services to you. When you request
              to tour a home, make an offer, or connect with a broker using our
              Services we will share certain information about your requests
              with other parties such as homeowners, lenders and real estate
              brokers to facilitate this request.
            </li>
            <li>
              <strong>With our Service Providers.</strong> We may share your
              information with other companies who are working on our behalf to
              provide you with our Services. The companies include technology,
              customer service, marketing and information security service
              providers that help us improve your experience on the Site or App,
              provide you with our Services, and secure your personal
              information while using our Site and App.
            </li>
            <li>
              <strong>Merger or Acquisition.</strong> We may share personal
              information when we do a business deal, or negotiate a business
              deal, involving the sale or transfer of all or a part of our
              business or assets. These deals can include any merger, financing,
              acquisition, or bankruptcy transaction or proceeding.
            </li>
            <li>
              <strong>Without Your Consent.</strong> We may share personal
              information without your consent in order to comply with a lawful
              legal request, comply with a law enforcement investigation, defend
              our legal rights or assist in emergency situations to protect the
              health and safety of our employees and agents, our customers, or
              any person.
            </li>
          </ul>
          <p>
            We may also share aggregated and/or anonymized data with others for
            their own uses.
          </p>
        </li>
        <br />
        <li>
          <h4>
            <a id="protectPersonalInfo" style={styles.headerText}>
              PROTECTING PERSONAL INFORMATION
            </a>
          </h4>
          <p>
            The protection and security of your personal information is
            important to us. We maintain technical, organizational, and
            procedural safeguards designed to protect our customer’s personal
            information from unauthorized access and misuse. Unfortunately, the
            transmission of information via the Internet is not completely
            secure. Although we strive to protect your personal information, we
            cannot guarantee the security of your personal information
            transmitted to our Site or App. Any transmission of personal
            information is at your own risk. We are not responsible for
            circumvention of any privacy settings or security measures contained
            on the Site or App. We encourage you to help us protect your
            personal information by securing your account using a strong
            password and using other measures available in your account to
            authenticate your identity prior to using the Services.
          </p>
        </li>
        <br />
        <li>
          <h4>
            <a id="infoChoices" style={styles.headerText}>
              INFORMATION CHOICES AND CHANGES
            </a>
          </h4>
          <ul>
            <li>
              <strong>Opt-Out.</strong> If you no longer want to receive
              marketing communications from us, our marketing emails provide
              instructions on how to “opt-out.” If you opt out, we may still
              send you non-marketing emails related to your use of the Services
              or for other purposes. Non-marketing emails include emails about
              your accounts and our business dealings with you.
            </li>
            <li>
              <strong>Requests.</strong> You may send requests to access or
              delete your personal information to our Contact Information below.
              You can request to change contact choices, opt-out of our sharing
              with others, and correct or update your personal information.
            </li>
            <li>
              <strong>Cookies.</strong> You can typically remove and reject
              cookies from our Site with your browser settings. Many browsers
              are set to accept cookies until you change your settings. If you
              remove or reject our cookies, it could affect how our Site works
              for you.
            </li>
            <li>
              <strong>Do Not Track Signals.</strong> Some newer web browsers
              have a "Do Not Track" preference that transmits a "Do Not Track"
              header to the websites you visit with information indicating that
              you do not want your activity to be tracked. We currently do not
              respond to browser "Do Not Track" signals, as there is no standard
              for how online services should respond to such signals. As
              standards develop, we may develop policies for responding to
              do-not-track signals that we will describe in this Privacy Policy.
            </li>
          </ul>
        </li>
        <br />
        <li>
          <h4>
            <a id="contactTorii" style={styles.headerText}>
              CONTACT INFORMATION
            </a>
          </h4>
          <p>
            We welcome your comments or questions about this privacy policy.
            <br />
            You may also contact us at our address:
            <br />
            <br />
            Torii, Inc.
            <br />
            2035 Sunset Lake Road
            <br />
            Suite B-2
            <br />
            Newark, Delaware 19702
          </p>
          <p>
            or at the email:{' '}
            <a href="mailto:support@toriihomes.com">support@toriihomes.com.</a>
          </p>
        </li>
        <br />
        <li>
          <h4>
            <a id="changes" style={styles.headerText}>
              CHANGES TO THIS PRIVACY POLICY
            </a>
          </h4>
          <p>
            We reserve the right to amend the Privacy Policy at any time, for
            any reason. The date of the last revision to the Privacy Policy will
            be indicated by the “Last updated” date at the beginning of this
            page. We encourage you to look for updates and changes to this
            Privacy Policy by checking this date when you access our Sites. We
            will notify you of any modifications to this Privacy Policy that
            might materially affect your rights prior to the change becoming
            effective by means of a message on this website or an email to you.
          </p>
        </li>
      </ol>
    </div>
  </PageBase>
);

export default PrivacyComponent;
